import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '../shared/auth/auth.service';
import { UserService } from '../user.service';
import { regex } from '../regex';

@Component({
	selector: 'narwhalia-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
	profileForm: FormGroup;
	passwordGroup: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		private toastr: ToastrService,
		private userService: UserService,
		private authService: AuthService,
		private router: Router,
		private translateService: TranslateService
	) {
		this.profileForm = this.formBuilder.group({
			nameFormControl: ['', Validators.required],
			emailFormControl: ['', [Validators.required, Validators.pattern(regex.email)]],
			passwordGroup: this.formBuilder.group({
				passwordFormControl: ['', Validators.pattern(regex.password)],
				passwordAgainFormControl: ['']
			}),
			walletFormControl: ['', Validators.required]
		});
	}

	ngOnInit() {
		this.userService.getProfile().subscribe(profile => {
			this.profileForm.get('nameFormControl').setValue(profile.name);
			this.profileForm.get('emailFormControl').setValue(profile.email);
			this.profileForm.get('walletFormControl').setValue(profile.wallet);
		});
	}

	onPasswordChange() {
		const passwordGroup = this.profileForm.get('passwordGroup');
		if (passwordGroup.get('passwordFormControl').value === '') {
			passwordGroup.get('passwordAgainFormControl').setValue('');
		}
	}

	saveProfile() {
		const { nameFormControl, emailFormControl } = this.profileForm.value;
		const { passwordFormControl, passwordAgainFormControl } = this.profileForm.value.passwordGroup;
		const walletFormControl = this.profileForm.getRawValue().walletFormControl;

		if (passwordFormControl !== passwordAgainFormControl) {
			this.translateService.get('form.error.notMatchingPw').subscribe(translatedText => this.toastr.error(translatedText));
		} else {
			this.userService.saveProfile(nameFormControl, emailFormControl, walletFormControl, passwordFormControl).subscribe();
		}
	}

	logout() {
		this.authService.logout();
		this.router.navigate(['']);
	}
}
